var map = {
	"./en-US": [
		164,
		9,
		2,
		3
	],
	"./en-US/": [
		164,
		9,
		2,
		3
	],
	"./en-US/a11y-labels": [
		356,
		3,
		7
	],
	"./en-US/a11y-labels.json": [
		356,
		3,
		7
	],
	"./en-US/all-star": [
		357,
		3,
		8
	],
	"./en-US/all-star.json": [
		357,
		3,
		8
	],
	"./en-US/art-prize/2018": [
		428,
		3,
		2
	],
	"./en-US/art-prize/2018.json": [
		428,
		3,
		2
	],
	"./en-US/art-prize/2019": [
		358,
		3,
		9
	],
	"./en-US/art-prize/2019.json": [
		358,
		3,
		9
	],
	"./en-US/art-prize/2020": [
		359,
		3,
		10
	],
	"./en-US/art-prize/2020.json": [
		359,
		3,
		10
	],
	"./en-US/art-prize/global": [
		360,
		3,
		11
	],
	"./en-US/art-prize/global.json": [
		360,
		3,
		11
	],
	"./en-US/auth": [
		361,
		3,
		12
	],
	"./en-US/auth.json": [
		361,
		3,
		12
	],
	"./en-US/faq": [
		362,
		3,
		13
	],
	"./en-US/faq.json": [
		362,
		3,
		13
	],
	"./en-US/footer": [
		363,
		3,
		14
	],
	"./en-US/footer.json": [
		363,
		3,
		14
	],
	"./en-US/global": [
		364,
		3,
		15
	],
	"./en-US/global.json": [
		364,
		3,
		15
	],
	"./en-US/handbook": [
		365,
		3,
		16
	],
	"./en-US/handbook.json": [
		365,
		3,
		16
	],
	"./en-US/home": [
		366,
		3,
		17
	],
	"./en-US/home.json": [
		366,
		3,
		17
	],
	"./en-US/index": [
		164,
		9,
		2,
		3
	],
	"./en-US/index.js": [
		164,
		9,
		2,
		3
	],
	"./en-US/ipad": [
		375,
		3,
		18
	],
	"./en-US/ipad-3d": [
		367,
		3,
		19
	],
	"./en-US/ipad-3d.json": [
		367,
		3,
		19
	],
	"./en-US/ipad-a11y": [
		368,
		3,
		20
	],
	"./en-US/ipad-a11y.json": [
		368,
		3,
		20
	],
	"./en-US/ipad-brushes": [
		369,
		3,
		21
	],
	"./en-US/ipad-brushes.json": [
		369,
		3,
		21
	],
	"./en-US/ipad-color": [
		370,
		3,
		22
	],
	"./en-US/ipad-color.json": [
		370,
		3,
		22
	],
	"./en-US/ipad-pencil": [
		371,
		3,
		23
	],
	"./en-US/ipad-pencil.json": [
		371,
		3,
		23
	],
	"./en-US/ipad-superpowers": [
		372,
		3,
		24
	],
	"./en-US/ipad-superpowers.json": [
		372,
		3,
		24
	],
	"./en-US/ipad-video": [
		373,
		3,
		25
	],
	"./en-US/ipad-video.json": [
		373,
		3,
		25
	],
	"./en-US/ipad-whats-new": [
		374,
		3,
		26
	],
	"./en-US/ipad-whats-new.json": [
		374,
		3,
		26
	],
	"./en-US/ipad.json": [
		375,
		3,
		18
	],
	"./en-US/meta": [
		376,
		3,
		27
	],
	"./en-US/meta.json": [
		376,
		3,
		27
	],
	"./en-US/navigation": [
		377,
		3,
		28
	],
	"./en-US/navigation.json": [
		377,
		3,
		28
	],
	"./en-US/pocket": [
		379,
		3,
		29
	],
	"./en-US/pocket-whats-new": [
		378,
		3,
		30
	],
	"./en-US/pocket-whats-new.json": [
		378,
		3,
		30
	],
	"./en-US/pocket.json": [
		379,
		3,
		29
	],
	"./en-US/prize": [
		380,
		3,
		31
	],
	"./en-US/prize.json": [
		380,
		3,
		31
	],
	"./en-US/sitemap": [
		381,
		3,
		32
	],
	"./en-US/sitemap.json": [
		381,
		3,
		32
	],
	"./en-US/support": [
		382,
		3,
		33
	],
	"./en-US/support.json": [
		382,
		3,
		33
	],
	"./ja": [
		165,
		9,
		4
	],
	"./ja/": [
		165,
		9,
		4
	],
	"./ja/auth": [
		383,
		3,
		34
	],
	"./ja/auth.json": [
		383,
		3,
		34
	],
	"./ja/faq": [
		384,
		3,
		35
	],
	"./ja/faq.json": [
		384,
		3,
		35
	],
	"./ja/footer": [
		385,
		3,
		36
	],
	"./ja/footer.json": [
		385,
		3,
		36
	],
	"./ja/global": [
		386,
		3,
		37
	],
	"./ja/global.json": [
		386,
		3,
		37
	],
	"./ja/handbook": [
		387,
		3,
		38
	],
	"./ja/handbook.json": [
		387,
		3,
		38
	],
	"./ja/home": [
		388,
		3,
		39
	],
	"./ja/home.json": [
		388,
		3,
		39
	],
	"./ja/index": [
		165,
		9,
		4
	],
	"./ja/index.js": [
		165,
		9,
		4
	],
	"./ja/ipad": [
		397,
		3,
		40
	],
	"./ja/ipad-3d": [
		389,
		3,
		41
	],
	"./ja/ipad-3d.json": [
		389,
		3,
		41
	],
	"./ja/ipad-a11y": [
		390,
		3,
		42
	],
	"./ja/ipad-a11y.json": [
		390,
		3,
		42
	],
	"./ja/ipad-brushes": [
		391,
		3,
		43
	],
	"./ja/ipad-brushes.json": [
		391,
		3,
		43
	],
	"./ja/ipad-color": [
		392,
		3,
		44
	],
	"./ja/ipad-color.json": [
		392,
		3,
		44
	],
	"./ja/ipad-preview": [
		393,
		3,
		45
	],
	"./ja/ipad-preview.json": [
		393,
		3,
		45
	],
	"./ja/ipad-superpowers": [
		394,
		3,
		46
	],
	"./ja/ipad-superpowers.json": [
		394,
		3,
		46
	],
	"./ja/ipad-video": [
		395,
		3,
		47
	],
	"./ja/ipad-video.json": [
		395,
		3,
		47
	],
	"./ja/ipad-whats-new": [
		396,
		3,
		48
	],
	"./ja/ipad-whats-new.json": [
		396,
		3,
		48
	],
	"./ja/ipad.json": [
		397,
		3,
		40
	],
	"./ja/meta": [
		398,
		3,
		49
	],
	"./ja/meta.json": [
		398,
		3,
		49
	],
	"./ja/navigation": [
		399,
		3,
		50
	],
	"./ja/navigation.json": [
		399,
		3,
		50
	],
	"./ja/pocket": [
		401,
		3,
		51
	],
	"./ja/pocket-whats-new": [
		400,
		3,
		52
	],
	"./ja/pocket-whats-new.json": [
		400,
		3,
		52
	],
	"./ja/pocket.json": [
		401,
		3,
		51
	],
	"./ja/sitemap": [
		402,
		3,
		53
	],
	"./ja/sitemap.json": [
		402,
		3,
		53
	],
	"./ja/support": [
		403,
		3,
		54
	],
	"./ja/support.json": [
		403,
		3,
		54
	],
	"./zh-CN": [
		166,
		9,
		5
	],
	"./zh-CN/": [
		166,
		9,
		5
	],
	"./zh-CN/a11y-labels": [
		404,
		3,
		55
	],
	"./zh-CN/a11y-labels.json": [
		404,
		3,
		55
	],
	"./zh-CN/all-star": [
		405,
		3,
		56
	],
	"./zh-CN/all-star.json": [
		405,
		3,
		56
	],
	"./zh-CN/art-prize/global": [
		406,
		3,
		57
	],
	"./zh-CN/art-prize/global.json": [
		406,
		3,
		57
	],
	"./zh-CN/auth": [
		407,
		3,
		58
	],
	"./zh-CN/auth.json": [
		407,
		3,
		58
	],
	"./zh-CN/faq": [
		408,
		3,
		59
	],
	"./zh-CN/faq.json": [
		408,
		3,
		59
	],
	"./zh-CN/footer": [
		409,
		3,
		60
	],
	"./zh-CN/footer.json": [
		409,
		3,
		60
	],
	"./zh-CN/global": [
		410,
		3,
		61
	],
	"./zh-CN/global.json": [
		410,
		3,
		61
	],
	"./zh-CN/handbook": [
		411,
		3,
		62
	],
	"./zh-CN/handbook.json": [
		411,
		3,
		62
	],
	"./zh-CN/home": [
		412,
		3,
		63
	],
	"./zh-CN/home.json": [
		412,
		3,
		63
	],
	"./zh-CN/index": [
		166,
		9,
		5
	],
	"./zh-CN/index.js": [
		166,
		9,
		5
	],
	"./zh-CN/ipad": [
		420,
		3,
		64
	],
	"./zh-CN/ipad-3d": [
		413,
		3,
		65
	],
	"./zh-CN/ipad-3d.json": [
		413,
		3,
		65
	],
	"./zh-CN/ipad-a11y": [
		414,
		3,
		66
	],
	"./zh-CN/ipad-a11y.json": [
		414,
		3,
		66
	],
	"./zh-CN/ipad-brushes": [
		415,
		3,
		67
	],
	"./zh-CN/ipad-brushes.json": [
		415,
		3,
		67
	],
	"./zh-CN/ipad-color": [
		416,
		3,
		68
	],
	"./zh-CN/ipad-color.json": [
		416,
		3,
		68
	],
	"./zh-CN/ipad-superpowers": [
		417,
		3,
		69
	],
	"./zh-CN/ipad-superpowers.json": [
		417,
		3,
		69
	],
	"./zh-CN/ipad-video": [
		418,
		3,
		70
	],
	"./zh-CN/ipad-video.json": [
		418,
		3,
		70
	],
	"./zh-CN/ipad-whats-new": [
		419,
		3,
		71
	],
	"./zh-CN/ipad-whats-new.json": [
		419,
		3,
		71
	],
	"./zh-CN/ipad.json": [
		420,
		3,
		64
	],
	"./zh-CN/meta": [
		421,
		3,
		72
	],
	"./zh-CN/meta.json": [
		421,
		3,
		72
	],
	"./zh-CN/navigation": [
		422,
		3,
		73
	],
	"./zh-CN/navigation.json": [
		422,
		3,
		73
	],
	"./zh-CN/pocket": [
		423,
		3,
		74
	],
	"./zh-CN/pocket.json": [
		423,
		3,
		74
	],
	"./zh-CN/powerup": [
		424,
		3,
		75
	],
	"./zh-CN/powerup.json": [
		424,
		3,
		75
	],
	"./zh-CN/prize": [
		425,
		3,
		76
	],
	"./zh-CN/prize.json": [
		425,
		3,
		76
	],
	"./zh-CN/sitemap": [
		426,
		3,
		77
	],
	"./zh-CN/sitemap.json": [
		426,
		3,
		77
	],
	"./zh-CN/support": [
		427,
		3,
		78
	],
	"./zh-CN/support.json": [
		427,
		3,
		78
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 611;
module.exports = webpackAsyncContext;